import BulkDeleteConfirmModal from "@/components/molecules/modals/BulkDeleteConfirmModal";
import { RESOURCES, ResourceKey } from "@/constants/resources";
import { useActionJobs } from "@/contexts/ActionJobsContext";
import { actionVerb } from "@/helpers/ResourceHelpers";
import { faBoxArchive, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useRef, useState } from "react";

interface IProps {
  resource: ResourceKey;
  selectedIds: string[];
  selectedRows: unknown[];
  //* Appelé une fois le job accepté par l'API
  onStarted: () => void;
}

//* Nom lisible d'une ligne, quelle que soit l'entité
export const getRowLabel = (row: any): string | null =>
  row?.name ??
  row?.label ??
  row?.fullname ??
  row?.user?.fullname ??
  ([row?.firstname, row?.lastname].filter(Boolean).join(" ") || null);

const BulkDeleteAction: FC<IProps> = ({
  resource,
  selectedIds,
  selectedRows,
  onStarted,
}) => {
  const { startBulkDelete } = useActionJobs();
  const config = RESOURCES[resource];
  const [show, setShow] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  //* Verrou synchrone : un second clic arrive avant que `isSubmitting` soit rendu
  const submittingRef = useRef(false);

  const names = selectedRows
    .map(getRowLabel)
    .filter((name): name is string => !!name);

  const handleConfirm = async () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setIsSubmitting(true);

    const started = await startBulkDelete(resource, selectedIds);

    submittingRef.current = false;
    setIsSubmitting(false);
    if (started) {
      setShow(false);
      onStarted();
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn formalys-bulk-bar-danger"
        onClick={() => setShow(true)}
      >
        <FontAwesomeIcon
          icon={config.effect === "archive" ? faBoxArchive : faTrashCan}
          className="me-2"
        />
        {actionVerb(config)}
      </button>
      <BulkDeleteConfirmModal
        show={show}
        config={config}
        count={selectedIds.length}
        names={names}
        isSubmitting={isSubmitting}
        onConfirm={handleConfirm}
        onCancel={() => setShow(false)}
      />
    </>
  );
};

export default BulkDeleteAction;
